var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.35742C3.75 4.05905 3.86853 3.77291 4.0795 3.56193C4.29048 3.35095 4.57663 3.23242 4.875 3.23242H18.375C18.6734 3.23242 18.9595 3.35095 19.1705 3.56193C19.3815 3.77291 19.5 4.05905 19.5 4.35742V6.60742C19.5 6.90579 19.3815 7.19194 19.1705 7.40292C18.9595 7.6139 18.6734 7.73242 18.375 7.73242C18.0766 7.73242 17.7905 7.6139 17.5795 7.40292C17.3685 7.19194 17.25 6.90579 17.25 6.60742V5.48242H12.75V18.9824H14.625C14.9234 18.9824 15.2095 19.1009 15.4205 19.3119C15.6315 19.5229 15.75 19.8091 15.75 20.1074C15.75 20.4058 15.6315 20.6919 15.4205 20.9029C15.2095 21.1139 14.9234 21.2324 14.625 21.2324H8.625C8.32663 21.2324 8.04048 21.1139 7.8295 20.9029C7.61853 20.6919 7.5 20.4058 7.5 20.1074C7.5 19.8091 7.61853 19.5229 7.8295 19.3119C8.04048 19.1009 8.32663 18.9824 8.625 18.9824H10.5V5.48242H6V6.60742C6 6.90579 5.88147 7.19194 5.6705 7.40292C5.45952 7.6139 5.17337 7.73242 4.875 7.73242C4.57663 7.73242 4.29048 7.6139 4.0795 7.40292C3.86853 7.19194 3.75 6.90579 3.75 6.60742V4.35742Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/textIcon.19c2bf09b7226e6aaff6f99996a6a390.svg";
export { ForwardRef as ReactComponent };